import { bus } from 'chimera/all/plugins/eventbus/bus'
import { logger } from 'chimera/all/plugins/eventbus/devLogger'

/**
 * Emit an event on the EventBus.
 *
 * @param {string} eventName
 * @param {object} event
 * @param {object} [options]
 * @param {object} [options.logData] - Override what the devLogger table displays (defaults to event)
 */
export function emit(eventName, event, { logData } = {}) {
  logger.log(eventName, {
    data: logData ?? event,
    fullData: event,
  })
  bus.$emit(eventName, event)
}
